import { useWidgetParam } from './hooks';

export const LayoutColors = {
  actionColor: '#3F85F5',
  primary: '#A5763D',
  primaryDark: '#8B6231',
  justBlue: '#2097F6',
  justBlueLigth: '#2097F61A',
  errorDark: '#C7372C',
  errorMain: '#DE1306',
  errorLight: '#FFD2CD',
  warningDark: '#FAAB00',
  warningMain: '#FBC800',
  warningLight: '#FFF5E5',
  successDark: '#2D996F',
  successMain: '#1DC483',
  successLight: '#D7EFE4',
  successLightest: '#30A6781A',
  blackDark: '#000000',
  blackMain: '#5F5F5F',
  blackLight: '#949494',
  whiteDark: '#F6F6F6',
  whiteLight: '#FFFFFF',
  gray: '#EEEEEE',
  grayMain: '#CDCDCD',
  greenDark: '#384E45',
} as const;

export const colors = {
  primary: {
    500: '#262BA6',
  },
  grey: {
    700: '#4D4D4D',
  },
  black: {
    200: '#E8E8E8',
    400: '#CDCDCD',
  },
  blue: {
    50: '#E1F2FF',
    100: '#E1EDF7',
    600: '#167CCD',
  },
  yellow: {
    500: '#976700',
  },
} as const;

const defaultState = {
  actionColor: LayoutColors.actionColor,
  cartIconColor: LayoutColors.whiteLight,
  selectionColor: LayoutColors.justBlue,
  successColor: LayoutColors.successMain,
  successColorDark: LayoutColors.successDark,
  errorColor: LayoutColors.errorMain,
  unavailableColor: colors.black[400],
  cartIconSize: '24px',
} as const;

type ThemeState = keyof typeof defaultState;

export const TypographyColors = {
  darkText: LayoutColors.blackDark,
  lightText: LayoutColors.blackLight,
  mainText: LayoutColors.blackMain,
  whiteText: LayoutColors.whiteLight,
};

export const themeKeys = Object.keys(defaultState) as ThemeState[];

export const useWidgetsTheme = (key: ThemeState) => useWidgetParam(key) || defaultState[key];
